import { FC, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { PlusIcon } from 'lucide-react';
import { toast } from 'react-toastify';
import api from '@/api/api';

interface AddSwitchboardProps {
  fileId: string;
  pageNumber: number;
  onAdd: () => Promise<void>;
  isDisabled: boolean;
}

const AddSwitchboard: FC<AddSwitchboardProps> = ({ fileId, pageNumber, onAdd, isDisabled }) => {
  const [newSwitchboardDialogVisible, setNewSwitchboardDialogVisible] = useState(false);
  const [newSwitchboard, setNewSwitchboard] = useState({ identifier_name: '' });

  const openNewSwitchboardDialog = () => {
    setNewSwitchboardDialogVisible(true);
  };

  const addNewSwitchboard = async () => {
    try {
      const response = await api.post(`add/switchboard/${fileId}/${pageNumber - 1}`, {
        ...newSwitchboard,
      });
      if (response.status === 200) {
        toast.success('Nový switchboard úspěšně přidán.');
        setNewSwitchboardDialogVisible(false);
        setNewSwitchboard({ identifier_name: '' });
        await onAdd();
      }
    } catch (error: any) {
      if (error?.response?.data?.detail) {
        toast.error(`Error: ${error.response.data.detail}`);
      } else {
        toast.error(`Chyba při ukládání switchboardu.`);
      }
    }
  };

  return (
    <>
      <Button
        icon={<PlusIcon size={18} />}
        className={'btn-secondary text-xs px-2 py-2 ml-auto'}
        iconPos={'right'}
        onClick={openNewSwitchboardDialog}
        disabled={isDisabled}
      >
        Přidat&nbsp;zařízení
      </Button>

      <Dialog
        draggable={false}
        style={{ width: '25rem' }}
        header="Přidat nové zařízení"
        visible={newSwitchboardDialogVisible}
        onHide={() => setNewSwitchboardDialogVisible(false)}
      >
        <div className="flex flex-col gap-4 mb-5">
          <div className="flex flex-col">
            <label htmlFor="name">Název zařízení</label>
            <InputText
              id="name"
              value={newSwitchboard.identifier_name}
              onChange={(e) => setNewSwitchboard({ ...newSwitchboard, identifier_name: e.target.value })}
            />
          </div>
        </div>
        <div className={'flex items-center justify-between'}>
          <Button label="Zrušit" onClick={() => setNewSwitchboardDialogVisible(false)} className={'btn-cancel'} />
          <Button label="Přidat" onClick={addNewSwitchboard} autoFocus={true} className={'btn-secondary'} />
        </div>
      </Dialog>
    </>
  );
};

export default AddSwitchboard;
